import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/beneficiaryservices'

export default {

  async get (id) {
    const headers = await getHeaders()
    return axios.get(prefix + '/' + id, { headers })
  },

  async search (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/search', criterias, { headers })
  },

  async detail (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/detail', criterias, { headers })
  }
}
